export const onSpecialChangeOnly = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  }

  export const onNumberOnlyChange = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("[0-9]").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };

  export const nameRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      const isValid = new RegExp("^[A-Za-z0-9.\\-_ ]*$").test(keyValue);
      if (!isValid) {
          event.preventDefault();
          return;
      }
    };

    export const numberRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      const isValid = new RegExp("[0-9]").test(keyValue);
      if (!isValid || event.target.value.length >= 10) {
          event.preventDefault();
          return;
      }
    };

    export const emailRegex = (event) => {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
  
      const isValid = /[a-zA-Z0-9._%+-@]/.test(keyValue);
  
      if (!isValid) {
        event.preventDefault();
        // return;
      }
    };